import { NsList } from '@/components/customElements';
import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

const InternalLinkedListStyle = styled(NsList)`
  grid-area: internal;
  justify-self: center;
  align-self: center;

  display: flex;
  justify-content: space-between;
  ${media.lessThan('medium')`
    width:100%;
  `}
  height: 2rem;
`;

const Item = styled.li`
  margin: 0 1rem;
`;

const InternalLink = styled(Link)`
  color: var(--font-color);
  font-size: 1.5rem;
  ${media.lessThan('medium')`
    font-size: 1.2rem;
  `}
  font-weight: bold;
  position: relative;
  text-align: center;
  vertical-align: top;
  text-decoration: none;
  line-height: 100%;
  &:after {
    display: block;
    position: relative;
    bottom: -15%;
    left: 0;
    content: '';
    width: 100%;
    height: 2px;
    background: var(--font-color);
  }

  &[data-here='false']:after {
    transform: scale(0, 1) !important;
    transform-origin: center top;
    transition: transform 0.3s;
  }
  &[data-here='false']:hover:after {
    transform: scale(1, 1) !important;
  }

  &[data-here='true']:after {
    transform: scale(1, 1) !important;
  }
`;

type Props = {
  here: boolean;
  to: string;
  type: Page;
  children: React.ReactNode;
};

const InternalLinkedListItem: React.VFC<Props> = ({ here, to, children }) => (
  <Item>
    <InternalLink to={to} data-here={here}>
      {children}
    </InternalLink>
  </Item>
);

export const InternalLinkedList = ({ type }: { type: Page }) => (
  <InternalLinkedListStyle>
    <InternalLinkedListItem to="/" here={type === `top`} type={type}>
      TOP
    </InternalLinkedListItem>
    <InternalLinkedListItem to="/about" here={type === `about`} type={type}>
      ABOUT
    </InternalLinkedListItem>
    <InternalLinkedListItem to="/posts" here={type === `post`} type={type}>
      POST
    </InternalLinkedListItem>
    <InternalLinkedListItem to="/works" here={type === `work`} type={type}>
      WORK
    </InternalLinkedListItem>
  </InternalLinkedListStyle>
);
